module.exports = __webpack_public_path__ + "static/media/1008537.e0e537f0.png";